import { SocketActionTypes, SocketActions } from './socket.actions';

export interface SocketState {
    messages: any[];
    contacts: any[];
    selectedContact: any;
    loadingContacts: boolean;
    loadingMessages: boolean;
    loadingEarlierMessages: boolean;
    latestMessage: any;
    settings: any;
    isblocked:boolean;
}

export const initialSocketState: SocketState = {
    messages: [],
    contacts: [],
    selectedContact: undefined,
    loadingContacts: false,
    loadingMessages: false,
    loadingEarlierMessages: false,
    latestMessage: undefined,
    settings: {},
    isblocked:false
};

export function SocketReducer(state = initialSocketState, action: SocketActions): SocketState {
    switch (action.type) {
        case SocketActionTypes.SendMessageSuccess: {
            const updatedContacts = [...state.contacts.filter(p=>p.id === action.payload.toKey),...state.contacts.filter(p=>p.id !== action.payload.toKey)].map(c => {///为输入
                if (c.id === action.payload.toKey) {
                    c.lastMessage = action.payload.timeStamp;
                }
                return c
            });
            //updatedContacts = [];
            return {
                ...state,
                messages: [
                    ...state.messages, {
                        id: action.payload.id,
                        context: action.payload.processContext.replace(/\n/g, "<br>"),
                        uid: action.payload.toKey,
                        HeadImg: action.payload.HeadImg,
                        type: "SEND",
                        // sendTime: Math.floor(((new Date()).getTime() + 3600000) / 1000),
                        sendTime: Math.floor(((new Date()).getTime()) / 1000),
                        messageType: action.payload.messageType,
                        IsOfficalUP: action.payload.isOfficalUP,
                        GID: action.payload.gid,
                        isOfficalSpeaker: action.payload.isOfficalSpeaker,
                    }],
                contacts: updatedContacts,
            };
        }
        case SocketActionTypes.SentMessageNotAllowed: {
            return {
                ...state,
                messages: [
                    ...state.messages, {
                        context: action.payload.context,
                        uid: action.payload.uid,
                        HeadImg: action.payload.HeadImg,
                        type: "SEND",
                        sendTime: action.payload.sendTime,
                        notAllowed: true,
                    }],
            };
        }
        case SocketActionTypes.MessageReceived: {
            const timestamp = new Date();
            if (state.messages.find(m => m.id === action.payload.id)) {
                return state
            }
            let updatedContact;
            if (!state.contacts.find(c => c.id === action.payload.key)) {
                updatedContact = [...[{
                    avatar: action.payload.HeadImg,
                    hasNew: true,
                    id: action.payload.key,
                    lastMessage: action.payload.timeStamp,
                    name: action.payload.nickname,
                    isRemind: action.payload.isRemind, // 是否强提醒
                    gid: action.payload.GID,
                    isOfficalUP: action.payload.IsOfficalUP,
                    isOfficalSpeaker: action.payload.isOfficalSpeaker,
                }],...state.contacts]
            } else {
                updatedContact = [...state.contacts.filter(p=>p.id === action.payload.key).map(c => {
                    if (c.id === action.payload.key) {
                        c.hasNew = true;
                        c.lastMessage = action.payload.timeStamp;
                        c.isRemind = action.payload.isRemind; // 是否强提醒
                    };
                    return c;
                }),...state.contacts.filter(p=>p.id !== action.payload.key)]
            }
            const transformedMessage = {
                ...action.payload,
                context: action.payload.context.replace(/\n/g, "<br>"),
                uid: action.payload.key,
                type: "RECEIVE",
                sendTime: Math.floor(action.payload.timeStamp),
                timestamp: action.payload.timeStamp,
                messageType: action.payload.messageType
            }
            return {
                ...state,
                messages: [
                    ...state.messages,
                    transformedMessage
                ],
                contacts: updatedContact,
                latestMessage: transformedMessage
            };
        }
        case SocketActionTypes.GetRecentlyRecords: {
            return {
                ...state,
                loadingContacts: true,
            };
        }
        case SocketActionTypes.GetRecentlyRecordsComplete: {
            return {
                ...state,
                loadingContacts: false,
                contacts: mergeArrayOnId(state.contacts, action.payload)
            };
        }
        case SocketActionTypes.GetRecentlyRecordsByUser: {
            
            return {
                ...state,
                loadingMessages: action.payload.latest ? true : false,
                loadingEarlierMessages: action.payload.latest ? false : true,
            };
        }
        case SocketActionTypes.GetRecentlyRecordsByUserComplete: {
            //console.log(action)
            const messages = action.payload.messages;
            const uid = action.payload.user;
            let merged = [];
            for (let i = 0; i < messages?.length; i++) {
                if (!(state.messages.find(m => m.id === messages[i].id))) {
                    merged.push(messages[i]);
                }
            }
            const updatedContacts = state.contacts.map(c => {
                if (c.id === uid) {
                    c.loaded = true;
                    c.allLoaded = action.payload.allLoaded;
                }
                return c;
            })
            return {
                ...state,
                contacts: updatedContacts,
                messages: [...state.messages.filter(m => !!m.id || m.uid !== action.payload.user), ...merged],
                loadingMessages: false,
                loadingEarlierMessages: false,
                isblocked : action.payload.isblocked
            };
        }
        case SocketActionTypes.MarkMessagesAsRead: {
            const found = state.contacts.find(c => (c.id === action.payload.uid || c.plainUserId === action.payload.uid) && c.hasNew)
            if (!found) {
                return state;
            } else {
                const updated = [...state.contacts].map(c => {
                    if (c.id === action.payload.uid || c.plainUserId === action.payload.uid) {
                        c.hasNew = false
                    }
                    return c;
                });
                return {
                    ...state,
                    contacts: updated
                };
            }
        }
        case SocketActionTypes.MarkAllMessagesAsRead: {
            const found = state.contacts.filter(c => c.hasNew)
            if (!found.length) {
                return state;
            } else {
                const updated = [...state.contacts].map(c => {
                    if (c.hasNew) {
                        c.hasNew = false
                    }
                    return c;
                });
                return {
                    ...state,
                    contacts: updated
                };
            }
        }
        case SocketActionTypes.RemoveContact: {
            return {
                ...state,
                contacts: state.contacts.filter(c => c.id !== action.payload),
                selectedContact: undefined
            }
        }
        case SocketActionTypes.ClearChatHistory: {
            console.log(action.payload)
            return {
                ...state,
                messages: state.messages.filter(m => {
                    return m.uid !== action.payload && m.toKey !== action.payload
                })
            }
        }
        case SocketActionTypes.SelectContact: {
            return {
                ...state,
                contacts: mergeArrayOnId(state.contacts, [action.payload]),
                selectedContact: action.payload
            }
        }
        case SocketActionTypes.DeselectContact: {
            return {
                ...state,
                selectedContact: undefined
            }
        }
        case SocketActionTypes.GetSettingsSuccess: {
            return {
                ...state,
                settings: action.payload
            }
        }
        case SocketActionTypes.ToggleSettingsFriendOnly: {
            return {
                ...state,
                settings: { ...state.settings, friendOnly: !state.settings.friendOnly }
            }
        }
        case SocketActionTypes.GetFollowStatusSuccess: {
            const updatedContacts = state.contacts.map(c => {
                if (c.id === action.payload.userId) {
                    c.followStatus = action.payload.followStatus
                }
                return c;
            })
            return {
                ...state,
                contacts: updatedContacts
            }
        }
        case SocketActionTypes.ChangeFollowStatusSuccess: {
            const updatedContacts = state.contacts.map(c => {
                if (c.id === action.payload.userId) {
                    c.followStatus = action.payload.followStatus
                }
                return c;
            })
            return {
                ...state,
                contacts: updatedContacts
            }
        }
        case SocketActionTypes.ClearAll: {
            return initialSocketState;
        }
        case SocketActionTypes.AddUserToBlock:{
            return {...state,
                isblocked:true
            }
        }
        
        default:
            return state;

        
    }
}

export function mergeArrayOnId(arr1, arr2) {
    let merged = [...arr1];

    for (let i = 0; i < arr2.length; i++) {
        if (!(merged.find(m => m.id === arr2[i].id))) {
            merged.push(arr2[i]);
        }
    }

    return merged;
}
